import React, { useState } from 'react';
import ApiService from '../Services/ApiService';

const useNormalizarDomicilio = () => {
    let { REACT_APP_APIPAYWALL } = process.env;
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState();
    const [errorNormalizar, setErrorNormalizar] = useState(null);

    const sendNormalizar = async (data) => {
        const pathUrl = `${REACT_APP_APIPAYWALL}Domicilio/Normalizar`;
        setErrorNormalizar(null);
        setIsLoading(true);
        return ApiService.post(pathUrl, data)
            .then(response => {
                if (response.code == "0000") {
                    setData(response.response);
                    setIsLoading(false);
                } else {
                    setIsLoading(false);
                    setErrorNormalizar(response.message);
                }
                return Promise.resolve(response);
            })
            .catch((error) => {
                setIsLoading(false);
                setErrorNormalizar(response.message);
                return Promise.reject(error);
            });
    };

    return [data, errorNormalizar, isLoading, sendNormalizar];

};


export default useNormalizarDomicilio;

